<div
  class="card card-border-1 rounded-xs centered full-width min-h-160 card-dms"
  *ngIf="company"
>
  <picture>
    <source [srcset]="company.logoWebp" type="image/webp" />
    <img [src]="company.logoPng" [alt]="company.name + '.'" loading="lazy" decoding="auto" />
  </picture>

  <div class="typography typography-align-center visually-impaired-description">
    {{ company.name }}
  </div>
</div>
